'use client';

import {
    AppstoreOutlined,
    BgColorsOutlined,
    BranchesOutlined,
    ImportOutlined,
    LayoutOutlined,
    ProfileOutlined,
    ShoppingOutlined,
    TrademarkCircleOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import type { MenuProps } from 'antd';
import { useMemo } from 'react';

type NavItem = {
    key: string;
    href: string;
    label: string;
    icon: React.ReactNode;
    isActive?: (path: string) => boolean;
};

const NAV_ITEMS: NavItem[] = [
    {
        key: '/orders',
        href: '/orders',
        label: 'Заказы',
        icon: <ProfileOutlined />,
    },
    {
        key: '/home-page',
        href: '/home-page',
        label: 'Лендинг',
        icon: <LayoutOutlined />,
    },
    {
        key: '/products',
        href: '/products',
        label: 'Товары',
        icon: <ShoppingOutlined />,
    },
    {
        key: '/categories',
        href: '/categories',
        label: 'Категории',
        icon: <AppstoreOutlined />,
    },
    {
        key: '/category-mapping',
        href: '/category-mapping',
        label: 'Маппер категорий',
        icon: <BranchesOutlined />,
    },
    {
        key: '/brands',
        href: '/brands',
        label: 'Бренды',
        icon: <TrademarkCircleOutlined />,
    },
    {
        key: '/colors',
        href: '/colors',
        label: 'Цвета',
        icon: <BgColorsOutlined />,
    },
    {
        key: '/import/runs',
        href: '/import/runs',
        label: 'Импорт',
        icon: <ImportOutlined />,
    },
];

function getSelectedKey(path: string, items: NavItem[]): string {
    let bestKey = '';
    let bestLen = -1;

    for (const it of items) {
        const base = it.href;
        const match = path === base || (base !== '/' && path.startsWith(`${base}/`));
        if (match) {
            const len = base.length;
            if (len > bestLen) {
                bestLen = len;
                bestKey = it.key;
            }
        }
    }

    if (bestKey === '') {
        for (const it of items) {
            if (it.href === path) return it.key;
        }
    }

    return bestKey;
}

type Props = {
    currentPath: string;
    collapsed: boolean;
    onNavigate: (href: string) => void;
};

export function ShellNav({ currentPath, collapsed, onNavigate }: Props) {
    const selectedKey = useMemo(() => getSelectedKey(currentPath, NAV_ITEMS), [currentPath]);

    const items: NonNullable<MenuProps['items']> = NAV_ITEMS.map(it => ({
        key: it.key,
        icon: it.icon,
        label: it.label,
        title: it.label,
    }));

    return (
        <Menu
            mode='inline'
            selectedKeys={selectedKey ? [selectedKey] : []}
            onClick={info => {
                if (typeof info.key === 'string') {
                    onNavigate(info.key);
                }
            }}
            inlineCollapsed={collapsed}
            items={items}
            style={{ borderInlineEnd: 'none' }}
        />
    );
}
